import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startSubmit } from 'redux-form';

import { pageOpened } from '../../actions/page-opened';
import goBack from '../../actions/go-back';
import { triggerPostPublish } from '../../actions/trigger-post-publish';
import { getPostEditorInitialPost } from '../../selectors/post-editor-selectors';
import { getPostPageEnabled } from '../../selectors/app-data-selectors';
import { POST_EDIT_PAGE } from '../../services/detect-route';
import { navigateToBlog } from '../../services/navigate-to-section';
import { getPostFormInitialValues } from '../../services/post-utils-rce';
import AppLoaded from '../../components/app-loaded';
import PostEditorPageLayout from '../../components/post-editor-page-layout';
import PostForm from '../../components/post-form';

export class PostEditorPage extends Component {
  componentDidMount() {
    this.props.pageOpened({ page: POST_EDIT_PAGE });
  }

  handleSubmit = () => this.props.publish();
  handlePublishButtonClick = () => this.props.submit();
  handleCancel = () => (this.props.isPostPageEnabled ? navigateToBlog('/') : this.props.goBack(`/`));

  render() {
    const { initialPost } = this.props;

    if (!initialPost) {
      return null;
    }

    return (
      <PostEditorPageLayout data-hook="post-editor-page">
        <PostForm
          initialValues={getPostFormInitialValues(initialPost)}
          onSubmit={this.handleSubmit}
          onPublishButtonClick={this.handlePublishButtonClick}
          onCancel={this.handleCancel}
          externalModalsEnabled
        />
        <AppLoaded />
      </PostEditorPageLayout>
    );
  }
}

PostEditorPage.propTypes = {
  publish: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  pageOpened: PropTypes.func.isRequired,
  initialPost: PropTypes.object,
  isPostPageEnabled: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  initialPost: getPostEditorInitialPost(state),
  isPostPageEnabled: getPostPageEnabled(state),
});

const mapDispatchToProps = {
  publish: triggerPostPublish,
  goBack,
  pageOpened,
  submit: () => startSubmit('post'),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostEditorPage);
